import { useQuery } from '@tanstack/react-query'

import { AosAdUser } from '../types/AosUser'
import { userProfileService } from '../userProfileService'
import { userProfileQueryKeys } from './userProfileQueryKeys'

export const useUserProfileQuery = (userId: number | undefined) =>
    useQuery<AosAdUser>({
        queryKey: userProfileQueryKeys.byId(userId),
        queryFn: () => userProfileService.getUserProfileById(userId as number),
        enabled: !!userId,
        staleTime: 5 * 60_000,
    })
